import React from 'react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
function LoggedInUser() {
    const navigate=useNavigate();
  useEffect(()=>{
   navigate('/dashboard');
  })
  // fetchData = async () => {
  //   try {
  //     // console.log("fetch data function called");
  //     const response = await axios.get('http://localhost:8080/profile', {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem('token')}`,
  //       },
  //     }); 
  //     // this.setState({ userData: response.data.user });
  //   //  console.log(this.userData.firstname);
  //     // const userData=response.data.user;
  //     console.log(response.data.user.firstname); 
  //     // console.log(userData.image);// Store the fetched data in state
  //   } catch (error) {
  //     console.error('Error fetching protected data:', error);
  //   }
  // };
  
  // componentDidMount(){
  //   this.fetchData();

  return (
    <div>
       {/* <Link to="/dashboard">  <button type="button" className="btn btn-gradient-info btn-fw">Already signed in click here</button> */}
       {/* </Link> */}
    </div>
  )
}

export default LoggedInUser